"use strict";
var decorators_1 = require("../util/decorators");
var metadata_1 = require("./metadata");
exports.Pipe = decorators_1.makeDecorator(metadata_1.PipeMetadata);
//# sourceMappingURL=decorators.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-metadata/src/core/pipes/decorators.js
// module id = 442
// module chunks = 0